// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__quths","form":"Form_form__e1yzW","formInput":"Form_formInput__sgOCo"};